export default {
    data: () => ({
        translations: {
            title: {
                el: "Email",
                en: "Email Configuration",
                it: "Email"
            },
            emailConfigurationInfo: {
                el: "Προσθέστε το email που επιθυμείτε να φαίνεται ως αποστολέας της καμπάνιας",
                en: "Please choose your email provider.",
                it: "Aggiungi l'email che vuoi far apparire come mittente della campagna"
            },
            alias: {
                el: "Alias (εμφανιζόμενο όνομα αποστολέα)",
                en: "Alias (Sender Name)",
                it: "Alias ​​(visualizza il nome del mittente)"
            },
            messageSenderName: {
                el: "Εμφανιζόμενο όνομα αποστολέα",
                en: "Message Sender Name",
                it: "Visualizzazione del nome del mittente"
            },
            messageSenderEmail: {
                el: "",
                en: "Message Sender Email",
                it: ""
            },
            emailFirstMethod: {
                el: "",
                en: "Email (First method)",
                it: ""
            },
            verifyEmail: {
                el: "",
                en: "Verify Email",
                it: ""
            },
            emailSecondMethodInfo: {
                el: "",
                en: `
                    Enter your email credentials in the table below to send email campaigns
                    through your email provider. Leave this blank and RoadCube's email
                    provider will be used.
                `,
                it: ""
            },
            host: {
                el: "",
                en: "Host",
                it: ""
            },
            name: {
                el: "Όνομα",
                en: "Name",
                it: "Nome"
            },
            email: {
                el: "Email",
                en: "Email",
                it: "Email"
            },
            password: {
                el: "Κωδικός",
                en: "Password",
                it: "Codice"
            },
            info: {
                el: "",
                en: `
                    * Sending email by priority. If the first method doesnt exists then
                    the second method will be used. If the second method doesnt exists
                    as well then RoadCube's email provider will be used.
                `,
                it: ""
            },
            moreInfo: {
                el: "Περισσότερες πληροφορίες...",
                en: "More Information...",
                it: "Maggiori informazioni..."
            },
            verify: {
                el: "Επαλήθευση",
                en: "Verify",
                it: "Verifica"
            },
            spfInfoExists: {
                el: '<p>Ελέγξτε αν έχετε ήδη μια εγγραφή <b>SPF</b> στο DNS σας.</p><br/> <p>Θα πρέπει να είναι μια εγγραφή τύπου <b>TXT</b> με μεταβλητές SPF (αρχίζει με "v=spf1").</p> <br/><p>Αυτός ο έλεγχος θα καθορίσει τα επόμενα βήματά σας.</p>',
                en: `<p>Check if you already have an  <b>SPF</b>  record in your DNS. </p><br/><p>It should be a <b>TXT</b>-type record with SPF variables (starts with "v=spf1").</p> <br/><p>This check will determine your next steps.</p>`,
                it: `<p>Verificare se è già presente un record <b>SPF</b> nel DNS.</p><br/><p> Dovrebbe essere un record di tipo <b>TXT</b> con variabili SPF (inizia con "v=spf1").</p> <br/><p>Questo controllo determinerà i passi successivi.</p>`
            },
            spfInfoNotFound: {
                el: 'Δεν βρήκα το αρχείο που περιγράφεται παραπάνω',
                en: `I did not find the record described above.`,
                it: `Non ho trovato la documentazione descritta sopra`
            },
            spfInfoCreateTitle: {
                el: 'Σε περίπτωση που δεν υπάρχει αρχείο, ακολουθήστε τις παρακάτω οδηγίες:',
                en: `In case there is no record, follow the instructions below:`,
                it: `Nel caso in cui non vi siano registrazioni, seguire le istruzioni riportate di seguito:`
            },
            spfInfoCreateStep1: {
                el: `Δημιουργία νέας εγγραφής <b>TXT</b>`,
                en: `Create a new <b>TXT</b> record`,
                it: `Creare un nuovo record <b>TXT</b>`
            },
            spfInfoCreateStep2: {
                el: `Συμπληρώστε το πεδίο <b>Name (Host)</b>. Ανάλογα με τον πάροχο, πιθανότατα θα πρέπει να ακολουθήσετε μία από αυτές τις επιλογές:`,
                en: `Fill in the <b>Name (Host)</b> field. Depending on the provider, you probably have to follow one of these options:`,
                it: `Compilare il campo <b>Name (Host)</b>. A seconda del provider, è probabile che si debba seguire una di queste opzioni:`
            },
            
            spfInfoCreateStep21: {
                el: "Αφήστε το κενό",
                en: "Leave it empty",
                it: "Lasciare vuoto"
            },
            
            spfInfoCreateStep22: {
                el: "Συμπληρώστε το με @",
                en: "Fill it with @",
                it: "Riempire con @"
            },
            
            spfInfoCreateStep23: {
                el: "Εισάγετε το domain name σας",
                en: "Enter your domain name",
                it: "Inserite il vostro nome di dominio"
            },
            
            spfInfoCreateStep3: {
                el: "Συμπληρώστε τo <b>Value</b> αυτής της εγγραφής με τη μεταβλητή που εμφανίζεται παρακάτω",
                en: `Fill in the <b>Value</b> of this record with variable displayed below`,
                it: "Compilare il <b>Value</b> di questo record con la variabile visualizzata sotto"
            },
            
            spfInfoFound: {
                el: 'Βρήκα το αρχείο που περιγράφεται παραπάνω.',
                en: `I found the record described above.`,
                it: `Ho trovato il disco descritto sopra.`
            },
            
            spfInfoEditTitle: {
                el: 'Υπέροχα! Ακολουθήστε τις οδηγίες που περιγράφονται παρακάτω:',
                en: `Great! Follow the instructions described below:`,
                it: `Ottimo! Seguite le istruzioni descritte di seguito:`
            },
            
            spfInfoEditStep1: {
                el: `Επεξεργαστείτε την εγγραφή <b>TXT</b> και συγχωνεύστε την υπάρχουσα τιμή <b>Value</b> με τη μεταβλητή που εμφανίζεται παρακάτω`,
                en: `Edit the <b>TXT</b> record and merge your existing <b>Value</b> with variable display below`,
                it: `Modificare il record <b>TXT</b> e unire il <b>Value</b> esistente con la variabile visualizzata qui sotto`
            },
            
            spfInfoEditStep1Ex1: {
                el: `Για παράδειγμα, αν ο τομέας σας έχει ήδη την εγγραφή:`,
                en: `For example, if your domain already has the record:`,
                it: `Ad esempio, se il dominio ha già il record:`
            },
            
            spfInfoEditStep1Ex2: {
                el: `Πρέπει να προσθέσετε σε αυτή τη μεταβλητή:`,
                en: `You need to add to this variable:`,
                it: `È necessario aggiungere a questa variabile:`
            },
            
            spfInfoEditStep1Ex3: {
                el: `Έτσι, η μεταβλητή που δημιουργήθηκε θα μοιάζει ως εξής:`,
                en: `So, created variable will look like this:`,
                it: `Quindi, la variabile creata avrà il seguente aspetto:`
            },
            dmarcGenerator1: {
                el: `Μπορείτε να χρησιμοποιήσετε τov `,
                en: `You can use our `,
                it: `È possibile utilizzare il nostro  `
            },
          
            dmarcGenerator2: {
                el: ` ή να χρησιμοποιήσετε τις συνιστώμενες ρυθμίσεις από παρακάτω.`,
                en: ` or use recommended settings from below.`,
                it: ` o le impostazioni consigliate di seguito.`
            },

            infoTick1_1: {
                el: "Δημιουργία νέας ",
                en: "Create a new ",
                it: "Creare un nuovo "
            },
            infoTick1_2: {
                el: " εγγραφής",
                en: " record",
                it: " record"
            },
            infoTick2_1: {
                el: "Συμπληρώστε το πεδίο ",
                en: "Fill in the ",
                it: "Compilare il campo "
            },
            infoTick2_2: {
                el: " αυτής της εγγραφής με τη μεταβλητή που εμφανίζεται παρακάτω.",
                en: " field of this record with variable displayed below.",
                it: " di questo record con la variabile visualizzata di seguito."
            },
            copy: {
                el: "Αντιγραφή",
                en: "Copy",
                it: "Copia"
            },
        
        }
    })
};
